import { Injectable } from "@angular/core";
import { DataProvider } from "../providers/data.provider";
import { Settings } from "../app.settings";
import { Observable } from "rxjs";

@Injectable()
export class ContactProvider {
  constructor(private dataProvider: DataProvider, private settings: Settings) {

  }

  public sendContactUsAsync = (dataUrl: string, contactUsData: any): Observable<Response> => {
    var contactUsDataJson = JSON.stringify(contactUsData);

    var emailSettings = {
      ToList: this.settings.emailTo,
      From: this.settings.emailFrom,
      Subject: "Contact Us Form",
      TemplateName: "ContactUsTemplate",
      TemplateModel: contactUsDataJson,
      WebsiteId: this.settings.websiteId,
      IpAddress: "N/A"
    };

    return this.dataProvider.postData(dataUrl, emailSettings);
  }
}